"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IdpServiceNS = void 0;
var IdpServiceNS;
(function (IdpServiceNS) {
    IdpServiceNS.IDP_SERVICE_ID = Symbol.for("IdpService");
})(IdpServiceNS = exports.IdpServiceNS || (exports.IdpServiceNS = {}));
//# sourceMappingURL=idp.types.js.map